import{isObject as t}from"@guildeducationinc/type-guards";import{isHtmlElementName as e}from"../HtmlElementName/HtmlElementName.js";var m=function(m){return t(m)&&"tagName"in m&&e(m.tagName)};export{m as isHtmlElement};
